import { useMemoModal, useModalDragConstraint } from "../../../components/Modal";
import type { TRangeSelection } from "../../useRangeSelectionChange";
import { ModalTabs, ModalTab } from "../../../components/ModalTabs";
import { ModalContainer } from "../ModalContainer";
import { FormulaViewer } from "./Layout";

export const useFormulaViewerModal = () => {
  const constraintRef = useModalDragConstraint();
  const modal = useMemoModal((p: { selection: TRangeSelection; width?: number; height?: number }) => {
    return (
      <ModalTabs {...p} active="viewer" constrainRef={constraintRef} onClose={() => modal.close()}>
        <ModalContainer hideSave cancelLabel="Close" cancelButtonType="closePrimary" onClose={() => modal.close()}>
          <ModalTab id="viewer" title="Formula viewer">
            <FormulaViewer selection={p.selection} />
          </ModalTab>
        </ModalContainer>
      </ModalTabs>
    );
  });
  return modal;
};
